import React from "react";
import { Helmet } from "react-helmet-async";
import { COMPANY } from "@/lib/content";

const OG_IMAGE = "https://static.prod-images.emergentagent.com/jobs/e03abf6c-9655-4102-9ef8-4569d8b55757/images/07989dbe760b944511c3cf2f90dd0361fd346e3fde935252a8477fd1453e7762.jpeg";

export const Seo = ({ title, description, path = "", image }) => {
  const fullTitle = title
    ? `${title} | ${COMPANY.shortName}`
    : `${COMPANY.shortName} | Real Estate Investment & Development in Charlotte, NC`;
  const url = `https://redwoodcaphold.com${path}`;
  const ogImage = image || OG_IMAGE;
  return (
    <Helmet>
      <title>{fullTitle}</title>
      <meta name="description" content={description} />
      <link rel="canonical" href={url} />
      <meta property="og:site_name" content={COMPANY.name} />
      <meta property="og:title" content={fullTitle} />
      <meta property="og:description" content={description} />
      <meta property="og:type" content="website" />
      <meta property="og:url" content={url} />
      <meta property="og:image" content={ogImage} />
      <meta name="twitter:card" content="summary_large_image" />
      <meta name="twitter:title" content={fullTitle} />
      <meta name="twitter:description" content={description} />
      <meta name="twitter:image" content={ogImage} />
    </Helmet>
  );
};

export default Seo;
